<div class="container">
    <div class="row g-3">
        <div class="col-12">
            <div class="d-flex">
                <span class="material-symbols-outlined fs-2 me-3 pointer" (click)="bankSystem()">
                    arrow_back
                </span>
                <h1> Secret Key OTP</h1>
                <button class="btn btn-primary ms-3" (click)="visible = true">Add OTP KEY</button>
            </div>
        </div>
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>System Name</th>
                        <th>OTP Client Id</th>
                        <th>OTP Client Secret</th>
                        <th>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let otp of otpItems">
                        <td>{{otp.SystemName}}</td>
                        <td>{{otp.ClientId}}</td>
                        <td>{{otp.ClientSecret}}</td>
                        <td class="text-end">
                            <button class="btn btn-warning me-2" (click)="viewOtp(otp)">
                                send test
                            </button>

                            <button class="btn btn-danger" (click)="deleteOtpKey(otp)">
                                delete
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<p-dialog header="Set OTP Key " [(visible)]="visible" [breakpoints]="{ '960px': '90vw' }" [style]="{ width: '50vw' }"
    (onHide)="resetItem()">
    <div class="row g-3">
        <!-- <div class="col-12">
            <h5>Realm : {{realmViewItems?.RealmName}}</h5>
        </div> -->
        <div class="col-12">
            <p>System Name</p>
            <input type="text" class="form-control" [(ngModel)]="SystemName">
        </div>
        <div class="col-12">
            <p>Api Service Name</p>
            <input type="text" class="form-control" [(ngModel)]="ApiServiceName">
        </div>
        <div class="col-12">
            <p>Api Key</p>
            <input type="text" class="form-control" [(ngModel)]="ApiKey">
        </div>
        <div class="col-12">
            <p>Api Secret</p>
            <input type="text" class="form-control" [(ngModel)]="ApiSecret">
        </div>
        <div class="col-12">
            <p>Api Url</p>
            <input type="text" class="form-control" [(ngModel)]="ApiUrl">
        </div>
        <div class="col-12">
            <button class="btn btn-cancel" (click)="resetItem()">Cancel</button>
            <button class="btn btn-primary ms-3" (click)="addOtpKey()">Add OTP Key</button>
        </div>
    </div>
</p-dialog>


<p-dialog header="Send Message Test" [(visible)]="viewSendOtp" [breakpoints]="{ '960px': '90vw' }"
    [style]="{ width: '50vw' }" (onHide)="resetItem()">
    <div class="row g-3">
        <div class="col-12">
            <h3>{{viewSendOtp?.SystemName}}</h3>
        </div>
        <div class="col-12">
            <p>Tel.</p>
            <input type="text" class="form-control" [(ngModel)]="otpTel">
        </div>
        <div class="col-12">
            <p>Message</p>
            <input type="text" class="form-control" [(ngModel)]="otpMessage">
        </div>
        <div class="col-12">
            <button class="btn btn-cancel" (click)="resetItem()">Cancel</button>
            <button class="btn btn-primary ms-3" (click)="sendOtp()">Send OTP</button>
        </div>
    </div>
</p-dialog>